import type { PlanStatus } from '@/types'
import { getStatusBadgeClassName } from '@/utils/statusConfig'

export function WavePlanStatus({ status }: { status: PlanStatus }) {
  return (
    <span
      className={`inline-flex items-center justify-center rounded px-3 py-0.5 text-sm font-medium ${getStatusBadgeClassName(status)}`}
    >
      {status}
    </span>
  )
}
